export default __webpack_public_path__ + "static/media/broken-robot.24ec0820.png";